import {
  REPRINT_CERTIFICATE_TYPE,
  REPRINT_CERTIFICATE_TYPE_CLEAR_DATA,
  REPRINT_CERTIFICATE_TYPE_ERROR,
  REPRINT_CERTIFICATE_TYPE_SUCCESS,
} from "./actionTypes";

export const reprintCertificateType = (ct, history) => {
  return {
    type: REPRINT_CERTIFICATE_TYPE,
    payload: { ct, history },
  };
};

export const reprintCertificateTypeSuccess = (success) => {
  return {
    type: REPRINT_CERTIFICATE_TYPE_SUCCESS,
    payload: success,
  };
};

export const reprintCertificateTypeError = (error) => {
  return {
    type: REPRINT_CERTIFICATE_TYPE_ERROR,
    payload: error,
  };
};

export const reprintCertificateTypeClearData = () => {
  return {
    type: REPRINT_CERTIFICATE_TYPE_CLEAR_DATA,
    payload: {},
  };
};
